<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            摄像头
        </div>
        <div style="padding: 20px;" class="oldestPageGov">

            <div>
                <Search :searchForm='searchForm' :searchData='searchData' v-on:getList='getList'>
                    <template slot="button">
                        <el-button type="primary"  @click="handleAdd()">设备绑定</el-button>
                    </template>
                    <!-- <template slot="rightButton">
                        <el-button type="success"  @click="open()">预览</el-button>
                    </template> -->
                </Search>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <div style="text-align: right;margin-bottom:5px">
                    <el-radio-group v-model="tableType" size="mini" @change="changeTableType">
                        <el-radio-button label="0">
                            <i class="el-icon-s-fold"></i>
                        </el-radio-button>
                        <el-radio-button  label="1">
                            <i class="el-icon-s-grid"></i>
                        </el-radio-button>
                    </el-radio-group>
                </div>
                <template v-if="tableType=='0'">
                    <el-table
                        :data="tableData"
                        :height="th-30"
                        v-loading="loading"
                        border
                        style="width: 100%;">
                        <el-table-column prop="name" label="名称" ></el-table-column>
                        <el-table-column prop="location" label="位置" ></el-table-column>
                        <el-table-column prop="address" label="地址" ></el-table-column>
                        <el-table-column prop="deviceId" label="设备号"></el-table-column>
                        <el-table-column prop="type" :formatter="getTypeName" label="绑定类型"></el-table-column>
                        <el-table-column prop="bindTime" :formatter="timefilter" label="绑定时间"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="220">
                            <template slot-scope="scope">
                                <el-button type="success" size="small" @click="handlePreview(scope.row)">预览</el-button>
                                <el-button type="success" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                                <el-button type="danger"  size="small" @click="handleUnbind(scope.row)">解绑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    
                </template>
                <template v-if="videoLoading&&tableType=='1'">
                    <el-row :gutter="20" :style="{height:th-30+'px','overflow-y':'auto'}">
                        <el-col :span="videoSpan" v-for="(item,i) in tableData" :key="i">
                            <div style="margin-bottom:5px;border: 1px solid #ebebeb;" @click="handlePreview(item)">
                                <div :style="{height:videoHeight+'px'}">
                                    <video
                                        :id="'videoRow'+i"
                                        preload="auto"
                                        class="video-js vjs-default-skin"
                                        style="width: 100%; height: 100%; object-fit: fill"
                                        >
                                        <source :src="item.url" type="application/x-mpegURL" />
                                    </video>
                                </div>
                                <div style="text-align:center;background: #fff;line-height: 30px;">
                                    <span>{{item.name+"："+item.location}}</span>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </template>
                <div style="text-align: left;background-color: #fff;padding: 10px;">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="current_change"
                        :current-page="currentPage4"
                        :page-sizes="[4, 9, 12, 20]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next"
                        :total="totalItems">
                    </el-pagination>
                    <div style="clear: both;"></div>
                </div>
            </div>
        </div>
        <el-dialog
            title="预览"
            :visible.sync="dialogVisible"
            fullscreen
            destroy-on-close
            :before-close="handleClose">
            <div :style='{"height":th+80+"px",width:"100%"}'>
                <video
                    ref="videoRef"
                    preload="auto"
                    controls
                    class="video-js vjs-default-skin"
                    style="width: 100%; height: 100%; object-fit: fill"
                    >
                    <source :src="videoSrc" type="application/x-mpegURL" />
                </video>
            </div>
        </el-dialog>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
        <Bind ref="bind" :platform='searchForm.platformList[0]' :governmentList='searchForm.governmentCodeList' v-on:getList="getList"></Bind>
    </div>
</template>
<script>
    import Edit from "./Edit";

    import Search from "@/components/Search";
    import {postAxios} from '@/common/axios';
    import {timefilters} from "@/common/times";
    import { getInstitutionCode } from "@/utils/auth";
    // import "videojs-contrib-hls"
    import Bind from "./Bind";
    import videojs from 'video.js'
    import 'videojs-contrib-hls'
    export default {
        name: "DHCameraPage",
        data(){
            return{
                videoSrc:"",
                tableType:'0',
                tableData:[],
                dialogVisible:false,
                showModalEdit:false,
                dialogVisibleRow:false,
                totalItems: 20,
                pageSize:20,
                currentPage:1,
                videoSpan:6,
                videoHeight:200,
                loading:false,
                videoLoading:true,
                th:0,
                videoData:'',
                searchForm:{
                    name: '',
                    type:-1,
                    platformList:[],
                    governmentCodeList:[]
                },
                searchData:'',
                options:[
                    {
                    label:'全部',
                    value:-1
                },{
                    label:'个人',
                    value:1
                },{
                    label:'机构',
                    value:2
                }],
                isParent:false
            }
        },
        components:{
            Search,Bind,Edit
        },
        created(){
            this.getHight();
            window.addEventListener('resize', this.getHight);
            this.init();
        },
        beforeDestroy(){
            for (let index = 0; index < this.tableData.length; index++) {
                videojs('videoRow'+index).dispose();  //销毁video实例，避免出现节点不存在 但是flash一直在执行,也避免重新进入页面video未重新声明
            }
        },
        destroyed() {
            if(this.governmentCodeList.length>0){
                window.removeEventListener('resize', this.getHight);
            }
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            /**
             * isParent:是否是只读模式，不可添加/解绑
             * plateform：平台，若为多个必是只读模式,若不为只读模式，
             * 平台不作为查询条件，可不传
             * 平台和平台Code不能有交集
             * 若只想查某个政府的数据，请不要传这个政府所属平台
             * govCode：平台Code可为多个
             */
            init:function(){
                this.searchData=[
                    {span:12,name:'名称',value:'name',type:'input'},
                    {span:12,name:'绑定类型',value:'type',type:'select',options:this.options},
                ]
                
                const query = this.$route.query;
                //判断是否只读
                this.isParent=query.isParent&&query.isParent=='true'?true:false;
                // this.searchForm.platformList.push("institution");
                this.searchForm.governmentCodeList.push(getInstitutionCode())
                //平台
                if(query.plateform && this.isParent){
                    const plateformList=query.plateform.split(",")
                    this.searchForm.platformList=this.searchForm.platformList.concat(plateformList);
                }
                // 平台Code
                const govCode = query.govCode
                if(govCode){
                    const govCodeList=govCode.split(",")
                    this.searchForm.governmentCodeList=this.searchForm.governmentCodeList.concat(govCodeList);
                    this.getHight();
                    window.addEventListener('resize', this.getHight);
                }else{
                    this.th = this.$store.state.tableHeight-10;
                    this.isParent=true;
                }
                this.videoSpan=6;
                this.videoHeight=(this.th-200)/3
                this.getList()
            },
            changeTableType(val){
                if(val=='0'){
                    for (let index = 0; index < this.tableData.length; index++) {
                        videojs('videoRow'+index).dispose();  //销毁video实例，避免出现节点不存在 但是flash一直在执行,也避免重新进入页面video未重新声明
                    }
                }else{
                    this.$nextTick(() => {
                        for (let index = 0; index < this.tableData.length; index++) {
                            this.getVideo('videoRow'+index)
                        }
                    })
                }
                
            },
            timefilter() {
                return timefilters(arguments[2]);
            },
            handleSizeChange(val){
                this.pageSize=val
                switch(val){
                    case 4:
                        this.videoSpan=12;
                        this.videoHeight=(this.th-105)/2
                        break;
                    case 9:
                        this.videoSpan=8;
                        this.videoHeight=(this.th-140)/3
                        break;
                    case 12:
                        this.videoSpan=6;
                        this.videoHeight=(this.th-200)/3
                        break;
                    case 20:
                        this.videoSpan=6;
                        this.videoHeight=(this.th-200)/3
                        break;
                }
                this.getList();
            },
            handleAdd(){
                this.$refs.bind.init();
            },
            getVideo (videoDom) {
                this.$nextTick(() => {
                    videojs(videoDom, {
                        bigPlayButton: true,
                        textTrackDisplay: false,
                        posterImage: false,
                        errorDisplay: false,
                        hls: {
                            withCredentials: true
                        }
                    }, function () {
                        this.play()
                    })
                })
            },
            handleClose(done){
                const videoDom = this.$refs.videoRef;   //不能用document 获取节点
                videojs(videoDom).dispose();  //销毁video实例，避免出现节点不存在 但是flash一直在执行,也避免重新进入页面video未重新声明
                done();
            },
            handleAllClose(done){
                for (let index = 0; index < this.tableData.length; index++) {
                    videojs('videoRow'+index).dispose();  //销毁video实例，避免出现节点不存在 但是flash一直在执行,也避免重新进入页面video未重新声明
                }
                done();
            },
            getSn(){
                return arguments[2].substring(0,9)
            },
            getTypeName(){
                return arguments[2]==1?"个人":"机构";
            },
            handlePreview(row){
                this.videoSrc=row.url
                this.dialogVisible=true;
                this.$nextTick(() => {
                    const videoDom = this.$refs.videoRef;
                    this.getVideo(videoDom)
                })
            },
            getList(isSearch) {
                if(isSearch){
                    this.currentPage=1;
                }
                if(this.tableType=='1'){
                    for (let index = 0; index < this.tableData.length; index++) {
                        videojs('videoRow'+index).dispose();  //销毁video实例
                    }
                    this.videoLoading=false;
                }
                this.loading = true;
                let data={
                    pageIndex: this.currentPage,
                    pageSize: this.pageSize,
                }
                Object.assign(data,this.searchForm);
                var that=this;
                this.loading = true;
                postAxios(this.$deviceUrl + "DhCamera/Page",data,this.searchForm.governmentCodeList.length===0).then(resolve=>{
                    this.tableData = resolve.list;
                    this.totalItems = resolve.total;
                    this.loading = false;
                    if(this.tableType=='1'){
                        this.videoLoading=true;
                        this.$nextTick(() => {
                            for (let index = 0; index < this.tableData.length; index++) {
                                this.getVideo('videoRow'+index)
                            }
                        })
                    }
                }).catch(()=>{
                    that.loading = false;
                })
            },
            getHight(){
                this.th=document.body.clientHeight-200;
            },
            current_change: function (currentPage) {
                this.currentPage = currentPage;
                this.getList();
            },

            
            handleEdit(row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
             toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            handleUnbind(row){
                this.$confirm("您确定要解绑该用户的设备吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    var that=this
                    postAxios(this.$deviceUrl + "DhCamera/Unbind",{dhcameraCode:row.dhcameraCode},false).then(()=>{
                        this.$message({
                            message: "解绑成功",
                            type: "success",
                        });
                        this.getList();
                    }).catch(()=>{
                        that.loading = false;
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消解绑",
                    });
                });
            }
        }
    }
</script>
<style>
    .el-table .success-row {
        background: #f0f9eb;
    }
</style>
<style lang="scss" scoped>
.oldestPageGov{
    .item{
        margin-bottom: 20px;
    }
    .demonstration{
        padding: 10px;
        line-height: 34px;
        font-size: 16px;
    }

    .mask {
        background-color: rgb(0, 0, 0);
        opacity: 0.3;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 199
    }
    .mask .lodingsIcon{
        /* margin-top: 47vh; */
        margin: 47vh auto;
        height: 6vh;
        width: 300px;
        font-size: 18px;
        color: white;
    }
    .lodingsIcon i{
        z-index: 200;
        font-size: 25px;
        margin-right:10px ;
    }

}

</style>
